import { throttle } from 'lodash'
import React, { useEffect, useRef, useState } from 'react'

// import ReactGA from 'react-ga'
// import ym from 'react-yandex-metrika'
import { newIsMobile } from '../../helpers/isMobile'
import { NewCardsIconRow } from '../icons/NewCardsIconRow'
import { NewCardsIconTable } from '../icons/NewCardsIconTable'
import NewFlatCardTwoStates from '../NewFlatCardTwoStates/NewFlatCardTwoStates'
import { NewFlatCardTwoStatesProps } from '../NewFlatCardTwoStates/NewFlatCardTwoStates.types'
import NewFlatCardTwoStatesCommercial from '../NewFlatCardTwoStates/NewFlatCardTwoStatesCommercial'
import LastFlatCard from '../UI/LastFlatCard/LastFlatCard'
import { PreloaderSpiner } from '../UI/PreloaderSpinner/PreloaderSpiner'
import { NewCardsCollectionProps } from './NewCardsCollection.types'

// const cardsAnalyticsHandler = (isOpen: boolean, position: string) => {
//   ReactGA.ga(
//     'send',
//     'event',
//     'main',
//     `projects ${position} list`,
//     isOpen ? 'hide' : 'show'
//   )
//   ym('reachGoal', 'projects list click', {
//     'projects list click': {
//       position: {
//         'click type': isOpen ? 'hide' : 'show',
//       },
//     },
//   })
// }

const startItems = 4

export const NewCardsCollection = (props: NewCardsCollectionProps) => {
  const {
    cards,
    SelectionId,
    showALL,
    title,
    noMetro,
    linkLastCard,
    type = 'flat',
  } = props

  // state variables
  const [itemsCount, setItemsCount] = useState<number | undefined>(
    showALL ? undefined : startItems
  )
  const [isOpen, setIsOpen] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)
  const [state, setState] = useState<string>('table')
  const [disableTransition, setDisableTransition] = useState(false)

  const cardsRef = useRef<HTMLDivElement>(null)

  const changeState = (type: string): void => {
    if (type === state) return

    setIsAnimating(true)
    setDisableTransition(() => {
      return true
    })

    setTimeout(() => {
      setState(type)
      setIsAnimating(false)

      setTimeout(
        () =>
          setDisableTransition(() => {
            return false
          }),
        300
      )
    }, 300)
  }

  const resizeHandler = throttle(() => {
    if (newIsMobile() && state !== 'table') {
      setState('table')
    }
  }, 500)

  const showMore = () => {
    setItemsCount(isOpen ? startItems : undefined)
    setIsOpen(!isOpen)

    // cardsAnalyticsHandler(isOpen, position)

    if (isOpen && cardsRef.current) {
      window.scrollTo(0, cardsRef.current.offsetTop)
    }
  }

  useEffect(() => {
    window.addEventListener('resize', resizeHandler)

    return () => {
      window.removeEventListener('resize', resizeHandler)
    }
  }, [cards, state])

  return (
    <section className='section'>
      <div className='new-cards__head'>
        {title && <h2 className='section__title'>{title}</h2>}
        <div className={`new-cards__controls new-cards__controls--${state}`}>
          <button
            onClick={() => {
              changeState('table')
            }}
          >
            <NewCardsIconTable />
          </button>
          <button
            onClick={() => {
              changeState('row')
            }}
          >
            <NewCardsIconRow />
          </button>
        </div>
      </div>
      {!cards.pending && cards.selections.items.length !== 0 ? (
        <div className='new-cards' ref={cardsRef}>
          <div
            className={`new-cards__items new-cards__items--${state} new-cards__items--collection ${
              isAnimating ? 'is-animating' : ''
            } ${disableTransition ? 'is-disable-tarnsitions' : ''}`}
          >
            <>
              {cards.selections.items.slice(0, itemsCount).map((card: any) => (
                <div key={card.ID}>
                  {type === 'flat' ? (
                    <NewFlatCardTwoStates
                      {...card}
                      selectionId={SelectionId}
                      state={state}
                      noMetro={noMetro}
                    />
                  ) : (
                    <NewFlatCardTwoStatesCommercial
                      {...card}
                      selectionId={SelectionId}
                      state={state}
                      noMetro={noMetro}
                    />
                  )}
                </div>
              ))}
              <div>
                <LastFlatCard state={state} link={linkLastCard} type={type} />
              </div>
            </>
          </div>
          {!showALL && (
            <div className='new-cards__btn'>
              <button className='btn btn--gray' onClick={showMore}>
                {!itemsCount ? 'Скрыть все' : 'Показать все'}
              </button>
            </div>
          )}
        </div>
      ) : (
        <PreloaderSpiner />
      )}
    </section>
  )
}
